import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import FiltersPopover from '../common/FiltersPopover/FiltersPopover'
import CollapsibleFilterSection from '../common/FiltersPopover/CollapsibleFilterSection'
import FilterButton from '../common/buttons/FilterButton'
import CheckBox from '../common/form/CheckBox'
import { FILTERS_BUTTON_ID } from './CoachesHeader'

import classes from './CoachesFiltersPopover.module.scss'

export const STATUS_OPTIONS = ['all', 'active', 'invited', 'inactive']
export const INITIAL_COACH_FILTERS = { status: 'all', withoutCommunity: false }

export const countCoachFilters = (filters) => (filters.status === 'all' ? 0 : 1) + (filters.withoutCommunity ? 1 : 0)

const CoachesFiltersPopover = ({ isOpen, toggle, currentFilters, onApply }) => {
  const { t } = useTranslation()
  const [staged, setStaged] = useState(currentFilters)

  useEffect(() => {
    if (isOpen) {
      setStaged(currentFilters)
    }
  }, [isOpen, currentFilters])

  const pendingCount = (staged.status !== currentFilters.status ? 1 : 0)
    + (staged.withoutCommunity !== currentFilters.withoutCommunity ? 1 : 0)

  const handleApply = () => {
    onApply(staged)
    toggle()
  }

  const handleClearAll = () => {
    onApply(INITIAL_COACH_FILTERS)
    toggle()
  }

  return (
    <FiltersPopover
      isOpen={isOpen}
      toggle={toggle}
      target={FILTERS_BUTTON_ID}
      pendingCount={pendingCount}
      onApply={handleApply}
      onClearAll={handleClearAll}
    >
      <CollapsibleFilterSection title={t('common.field.status')}>
        <div className={classNames(classes.statusOptions, 'd-flex flex-wrap py-1')}>
          {STATUS_OPTIONS.map(status => (
            <FilterButton
              key={status}
              text={t(`coaches.header.filters.${status}`)}
              onClick={() => setStaged(prev => ({ ...prev, status }))}
              isActive={staged.status === status}
            />
          ))}
        </div>
      </CollapsibleFilterSection>

      <CollapsibleFilterSection title={t('coaches.filtersPopover.account')}>
        <CheckBox
          id='filter-without-community'
          isSelected={staged.withoutCommunity}
          onClick={() => setStaged(prev => ({ ...prev, withoutCommunity: !prev.withoutCommunity }))}
          label={t('coaches.filtersPopover.freeAccount')}
          size='sm'
        />
      </CollapsibleFilterSection>
    </FiltersPopover>
  )
}

CoachesFiltersPopover.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  currentFilters: PropTypes.shape({
    status: PropTypes.oneOf(STATUS_OPTIONS).isRequired,
    withoutCommunity: PropTypes.bool.isRequired,
  }).isRequired,
  onApply: PropTypes.func.isRequired,
}

export default CoachesFiltersPopover
